import React, { useState } from 'react';
import { Modal, Form, Input, Button, Row, Col, Space, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

const ResetPasswordModal = ({ visible = false, user, onClose, onSubmit }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [generatedPassword, setGeneratedPassword] = useState('');

  const generatePassword = () => {
    const length = 12;
    const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*';
    let password = '';
    for (let i = 0; i < length; i++) {
      password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    setGeneratedPassword(password);
    form.setFieldsValue({ password });
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await onSubmit(values.password);
      setGeneratedPassword('');
      form.resetFields();
    } catch (error) {
      message.error('Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setGeneratedPassword('');
    form.resetFields();
    onClose();
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(generatedPassword);
    message.success('Password copied to clipboard');
  };

  return (
    <Modal
      title={`Reset Password for ${user?.name}`}
      open={visible}
      onCancel={handleClose}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item>
          <Button type="primary" block onClick={generatePassword}>
            Generate Secure Password
          </Button>
        </Form.Item>

        <Form.Item
          label="New Password"
          name="password"
          rules={[
            { required: true, message: 'Please enter or generate password' },
            { min: 8, message: 'Password must be at least 8 characters' },
          ]}
        >
          <Input.Password placeholder="Enter or generate new password" />
        </Form.Item>

        {generatedPassword && (
          <Row gutter={8} style={{ marginBottom: 16 }}>
            <Col flex="auto">
              <Input
                value={generatedPassword}
                readOnly
                type="text"
              />
            </Col>
            <Col>
              <Button
                icon={<CopyOutlined />}
                onClick={copyToClipboard}
              >
                Copy
              </Button>
            </Col>
          </Row>
        )}

        <Space style={{ width: '100%' }} direction="vertical">
          <Button
            type="primary"
            block
            loading={loading}
            onClick={() => form.submit()}
          >
            Reset Password
          </Button>
          <Button
            block
            onClick={handleClose}
          >
            Cancel
          </Button>
        </Space>
      </Form>
    </Modal>
  );
};

export default ResetPasswordModal;
